enum TrackStatus {
  DELIVERED = 'DELIVERED',
  FAILURE = 'FAILURE',
  PRE_TRANSIT = 'PRE_TRANSIT',
  RETURNED = 'RETURNED',
  TRANSIT = 'TRANSIT',
  UNKNOWN = 'UNKNOWN',
}

type JSONTrack = {
  location: Location;
  object_created: string;
  object_id: string;
  object_updated: string;
  status: string;
  status_date: string;
  status_details: string;
};

type Track = {
  location: Location;
  objectCreated: string;
  objectId: string;
  objectUpdated: string;
  status: TrackStatus;
  statusDate: string;
  statusDetails: string;
};

type Location = {
  city: string;
  country: string;
  state: string;
  zip: string;
};

type JSONTransactionSearchTrack = { location?: Location | null } & Omit<JSONTrack, 'location'>;
type TransactionSearchTrack = { location?: Location | null } & Omit<Track, 'location'>;

const transactionSearchTrackFromJSON = (
  jsonTrack: JSONTransactionSearchTrack,
): TransactionSearchTrack => ({
  location: jsonTrack.location
    ? {
        city: jsonTrack.location.city,
        country: jsonTrack.location.country,
        state: jsonTrack.location.state,
        zip: jsonTrack.location.zip,
      }
    : undefined,
  objectCreated: jsonTrack.object_created,
  objectId: jsonTrack.object_id,
  objectUpdated: jsonTrack.object_updated,
  status: <TrackStatus>jsonTrack.status,
  statusDate: jsonTrack.status_date,
  statusDetails: jsonTrack.status_details,
});

export default Track;
export {
  JSONTrack,
  JSONTransactionSearchTrack,
  TrackStatus,
  TransactionSearchTrack,
  transactionSearchTrackFromJSON,
};
